import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'

export const api = {
  getDashboardKanBan: ipConfig.api_mwclg + '/mcp/bi/getAppCompanyBusiVolumeKanBan' // 工作台数据
}

// 工作台数据
export function getDashboardKanBan (data) {
  return axios({
    url: api.getDashboardKanBan,
    method: 'post',
    data
  })
}
